/* global SideDrawer */

if (!customElements.get('facet-filters')) {

  // ALEX – START – Custom – Translate filters & active-chips on load and update
  (async () => {
    // 1) logical → JSON-column map
    const propertyMap = {
      filter_colour:   'extra_parent_colour',
      filter_format:   'extra_format',
      filter_seal:     'extra_seal',
      filter_window:   'extra_window',
      filter_material: 'extra_material',
    };

    // 2) runner that handles translations
    async function translateFilters() {
      const isoCode = document.getElementById('store-iso-code')?.value;
      if (!isoCode) return;

      // 3) collect all facet inputs and group by JSON-column
      const inputs = Array.from(document.querySelectorAll(
        '.facets__filters input[type="checkbox"], .facets__filters input[type="radio"]'
      ));
      const filters = inputs.reduce((acc, input) => {
        const logical = input.name.split('.').pop();  // e.g. "filter_colour"
        const col     = propertyMap[logical];
        if (!col) return acc;
        acc[col] = acc[col] || new Set();
        acc[col].add(input.value);
        return acc;
      }, {});

      // 4) build query string
      const params = new URLSearchParams({ iso_code: isoCode });
      for (const [col, set] of Object.entries(filters)) {
        set.forEach(val => params.append(`filters[${col}][]`, val));
      }

      // 5) fetch translations
      let translations;
      try {
        const res = await fetch(`https://api-shopify.enveseur.com/shopify-collection/filter-translations?${params}`);
        if (!res.ok) throw new Error(res.statusText);
        translations = await res.json();
      } catch (e) {
        console.error('Filter translation failed:', e);
        return;
      }

      // 6) apply to input labels
      inputs.forEach(input => {
        const logical = input.name.split('.').pop();
        const col     = propertyMap[logical];
        const orig    = input.value;
        const txtEl   = input.closest('li').querySelector('label .flex-auto');
        if (txtEl && translations[col]?.[orig]) {
          txtEl.textContent = translations[col][orig];
        }
      });

      // 7) translate active-filters chips
      document.querySelectorAll('.active-filters .active-filter').forEach(link => {
        // grab the svg so we can re-attach it
        const svg = link.querySelector('svg');
      
        // 1) get the chip’s original label text
        //    (DOM still has English, since we haven’t clobbered it yet)
        const orig = link.textContent.trim();
      
        // 2) find which column’s map has a translation for orig
        //    “translations” is { extra_parent_colour: { Black:"Negro", … }, … }
        let colKey = Object
          .entries(translations)
          .find(([, map]) => Object.prototype.hasOwnProperty.call(map, orig))
          ?.[0];
      
        // 3) look up the translated label, or fallback to orig
        const label = colKey ? translations[colKey][orig] : orig;
      
        // 4) rebuild the link contents
        link.innerHTML = '';
        if (svg) link.appendChild(svg);
        link.insertAdjacentText('beforeend', ' ' + label);
      });
    }

    // 8) Runner that sorts the colour filter alphabetically
    function sortColourFilter() {
      const details = document.getElementById('filter-filter.v.m.property.filter_colour');
      if (!details) return;
      const list    = details.querySelector('ul');
      const isoCode = document.getElementById('store-iso-code')?.value || undefined;
    
      // 1) grab all <li> and figure out how many were visible originally
      const allItems       = Array.from(list.querySelectorAll('li'));
      const originallyVis  = allItems.filter(li => !li.classList.contains('js-hidden')).length;
    
      // 2) sort them by the _translated_ label text
      allItems.sort((a, b) => {
        const aText = a.querySelector('label .flex-auto')?.textContent.trim() || '';
        const bText = b.querySelector('label .flex-auto')?.textContent.trim() || '';
        return aText.localeCompare(bText, isoCode, { sensitivity: 'base' });
      });
    
      // 3) re-append in sorted order
      allItems.forEach(item => list.appendChild(item));
    
      // 4) *then* enforce “only N visible”
      allItems.forEach((item, idx) => {
        if (idx < originallyVis) {
          item.classList.remove('js-hidden');
        } else {
          item.classList.add('js-hidden');
        }
      });
    
      // 5) ensure the “Show More” button exists if needed
      const hasMoreBtn = !!details.querySelector('.js-show-more');
      if (allItems.length > originallyVis && !hasMoreBtn) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'filter__more js-show-more';
        btn.textContent = 'Show more';
        list.parentElement.appendChild(btn);
      }
    }

    // 9) Runner that sorts the sizes
    function sortSizeFilterByArea() {
      const details = document.getElementById('filter-filter.v.m.property.size_internal');
      if (!details) return;
    
      const list = details.querySelector('ul');
      if (!list) return;
    
      const items = Array.from(list.querySelectorAll('li')).filter(li => li.querySelector('input'));
      if (!items.length) return;
    
      const originallyVisible = items.filter(li => !li.classList.contains('js-hidden')).length;
      const collator = new Intl.Collator(document.getElementById('store-iso-code')?.value || undefined, {
        numeric: true,
        sensitivity: 'base'
      });
    
      let parsedCount = 0;
      const sortable = items.map(li => {
        const txtEl   = li.querySelector('label .flex-auto');
        const label   = txtEl?.textContent.trim() || '';
        const value   = li.querySelector('input')?.value || '';
        const parsed  = parseWidthHeight(label) || parseWidthHeight(value);
        if (parsed) parsedCount++;
        return { li, label: label || value, parsed };
      });
    
      if (parsedCount === 0) {
        console.warn('[size sort] No values parsed, skipping.');
        return;
      }
    
      sortable.sort((a, b) => {
        const pa = a.parsed, pb = b.parsed;
    
        // Parsed first
        if (pa && !pb) return -1;
        if (!pa && pb) return 1;
    
        if (pa && pb) {
          // 1) compare first number as shown (width)
          if (pa.first !== pb.first) return pa.first - pb.first;
          // 2) then second number (height)
          if (pa.second !== pb.second) return pa.second - pb.second;
          // Optional: if equal, area/min/max are identical; fall through
        }
    
        // Fallback to label text (handles "(C7)" vs "(44 labels)")
        return collator.compare(a.label, b.label);
      });
    
      const frag = document.createDocumentFragment();
      sortable.forEach(({ li }) => frag.appendChild(li));
      list.appendChild(frag);
    
      // Restore how many should be visible
      sortable.forEach(({ li }, idx) => {
        if (idx < originallyVisible) li.classList.remove('js-hidden');
        else li.classList.add('js-hidden');
      });
    
      // Ensure "Show more" button
      const hasMoreBtn = !!details.querySelector('.js-show-more');
      if (items.length > originallyVisible && !hasMoreBtn) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'filter__more js-show-more';
        btn.textContent = 'Show more';
        list.parentElement.appendChild(btn);
      }
    }
    function parseWidthHeight(text = '') {
      // e.g. "162 x 229 mm", "110×220 (DL)", "82 x 113 mm (C7)"
      const rx = /(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)/i;
      const m = rx.exec(text);
      if (!m) return null;
      const w = parseFloat(m[1].replace(',', '.'));
      const h = parseFloat(m[2].replace(',', '.'));
      return {
        first:  w,          // keep the written order
        second: h,
        min:    Math.min(w, h),
        max:    Math.max(w, h),
        area:   w * h
      };
    }

    // 10) hook into page load & AJAX-update event
    async function onFiltersUpdated() {
      await translateFilters(); // wait for the labels to be translated…
      sortColourFilter(); // then re-sort by the _new_ text
      sortSizeFilterByArea(); // then re-sort sizes
    }
    
    document.addEventListener('DOMContentLoaded', onFiltersUpdated);
    document.addEventListener('on:facet-filters:updated', onFiltersUpdated);
    
  })();
  // ALEX – END – Custom
  
  class FacetFilters extends SideDrawer {
    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.historyChangeHandler);

      if (this.breakpointChangeHandler) {
        window.removeEventListener('on:breakpoint-change', this.breakpointChangeHandler);
      }
    }

    init() {
      this.filteringEnabled = this.dataset.filtering === 'true';
      this.sortingEnabled = this.dataset.sorting === 'true';
      this.form = document.getElementById('facets');
      this.results = document.getElementById('filter-results');
      this.expanded = [];
      this.filterChangeTimeout = null;

      this.handleBreakpointChange();
      this.addElements();
      this.addListeners();

      this.historyChangeHandler = this.historyChangeHandler || this.handleHistoryChange.bind(this);
      window.addEventListener('popstate', this.historyChangeHandler);
    }

    addElements() {
      if (this.filteringEnabled) {
        this.filters = this.querySelector('.facets__filters');
        this.activeFilters = this.querySelector('.facets__active-filters');
        this.activeFiltersList = this.querySelector('.active-filters');
        this.activeFiltersHeader = this.querySelector('.active-filters-header');
        this.footer = this.querySelector('.facets__footer');
      }

      if (this.sortingEnabled) {
        this.mobileSortByOptions = this.querySelectorAll('.js-drawer-sort-by');
        this.desktopSortBy = document.querySelector('.products-toolbar__sort');
      }
    }

    addListeners() {
      if (this.filteringEnabled) {
        this.breakpointChangeHandler = this.breakpointChangeHandler
          || this.handleBreakpointChange.bind(this);
        this.filters.addEventListener('click', this.handleFiltersClick.bind(this));
        this.filters.addEventListener('input', this.handleFilterChange.bind(this));
        this.filters.addEventListener('change', this.handleFilterChange.bind(this));
        this.activeFilters.addEventListener('click', this.handleActiveFiltersClick.bind(this));
        window.addEventListener('on:breakpoint-change', this.breakpointChangeHandler);
      }

      if (this.sortingEnabled) {
        this.desktopSortBy.addEventListener('change', this.handleFilterChange.bind(this));
      }
    }

    /**
     * Handles viewport breakpoint changes.
     */
    handleBreakpointChange() {
      if (theme.mediaMatches.lg) {
        this.setAttribute('open', '');
        this.setAttribute('aria-hidden', 'false');
        this.removeAttribute('aria-modal');
        this.removeAttribute('role');
      } else {
        this.close();
        this.setAttribute('role', 'dialog');
        this.setAttribute('aria-modal', 'true');
        this.setAttribute('aria-hidden', 'true');
        this.hidden = false;
      }
    }

    /**
     * Handles 'input' events on the filters and 'change' events on the sort by dropdown.
     * @param {object} evt - Event object.
     */
    handleFilterChange(evt) {
      // Only allow price 'change' events
      if (evt.type === 'change' && !(evt.target.id?.includes('price-range') || evt.target.id?.includes('sort-by'))) return;

      // Dont reload when typing a price
      if (evt.target.id?.includes('price-range') && evt.constructor.name === 'InputEvent') return;

      const timeoutDelay = 500;

      clearTimeout(this.filterChangeTimeout);

      this.filterChangeTimeout = setTimeout(() => {
        const formData = new FormData(this.form);
        const searchParams = new URLSearchParams(formData);
        const emptyParams = [];

        if (this.sortingEnabled) {
          let currentSortBy = searchParams.get('sort_by');

          // Keep the mobile facets form sync'd with the desktop sort by dropdown
          if (evt.target.tagName === 'CUSTOM-SELECT') {
            this.mobileSortByOptions.forEach((option) => {
              option.checked = option.value === evt.detail.selectedValue;
              currentSortBy = evt.detail.selectedValue;
            });
          }

          // Set the 'sort_by' parameter.
          searchParams.set('sort_by', currentSortBy);
        }

        // Get empty parameters.
        searchParams.forEach((value, key) => {
          if (!value) emptyParams.push(key);
        });

        // Remove empty parameters.
        emptyParams.forEach((key) => {
          searchParams.delete(key);
        });

        this.applyFilters(searchParams.toString(), evt);
      }, timeoutDelay);
    }

    /**
     * Handles 'click' events on the filters.
     * @param {object} evt - Event object.
     */
    handleFiltersClick(evt) {
      const { target } = evt;

      // Filter 'clear' button clicked.
      if (target.matches('.js-clear-filter')) {
        evt.preventDefault();
        this.applyFilters(new URL(evt.target.href).searchParams.toString(), evt);
      }

      // Filter 'show more' button clicked.
      if (target.matches('.js-show-more')) {
        const filter = target.closest('.filter');
        target.remove();

        filter.querySelectorAll('li').forEach((el) => {
          el.classList.remove('js-hidden');
        });

        if (!this.expanded.includes(filter.id)) {
          this.expanded.push(filter.id);
        }
      }
    }

    /**
     * Handles 'click' events on the active filters.
     * @param {object} evt - Event object.
     */
    handleActiveFiltersClick(evt) {
      if (evt.target.tagName !== 'A') return;
      evt.preventDefault();
      this.applyFilters(new URL(evt.target.href).searchParams.toString(), evt);
    }

    /**
     * Handles history changes (e.g. back button clicked).
     * @param {object} evt - Event object.
     */
    handleHistoryChange(evt) {
      if (evt.state !== null) {
        let searchParams = '';

        if (evt.state && evt.state.searchParams) {
          ({ searchParams } = evt.state);
        }

        this.applyFilters(searchParams, null, false);
      }
    }

    /**
     * Fetches the filtered/sorted page data and updates the current page.
     * @param {string} searchParams - Filter/sort search parameters.
     * @param {object} evt - Event object.
     * @param {boolean} [updateUrl=true] - Update url with the selected options.
     */
    async applyFilters(searchParams, evt, updateUrl = true) {
      try {
        // Preserve the current element focus
        const activeElementId = document.activeElement.id;

        // Disable infinite scrolling.
        const customPagination = document.querySelector('custom-pagination');
        if (customPagination) customPagination.dataset.pauseInfiniteScroll = 'true';

        // Set loading state.
        this.results.classList.add('is-loading');

        // Disable "Show X results" button until submission is complete.
        const closeBtn = this.querySelector('.js-close-drawer-mob');
        closeBtn.ariaDisabled = 'true';
        closeBtn.classList.add('is-loading');

        // Use Section Rendering API for the request, if possible.
        let fetchUrl = `${window.location.pathname}?${searchParams}`;
        if (this.form.dataset.filterSectionId) {
          fetchUrl += `&section_id=${this.form.dataset.filterSectionId}`;
        }

        // Cancel current fetch request. (Raises an exception)
        if (this.applyFiltersFetchAbortController) {
          this.applyFiltersFetchAbortController.abort('Request changed');
        }
        this.applyFiltersFetchAbortController = new AbortController();

        // Fetch filtered products markup.
        const response = await fetch(fetchUrl, {
          method: 'GET',
          signal: this.applyFiltersFetchAbortController.signal
        });

        if (response.ok) {
          const tmpl = document.createElement('template');
          tmpl.innerHTML = await response.text();

          // Restore UI state.
          this.form.querySelectorAll('details-disclosure > details').forEach((existingFilter) => {
            const target = tmpl.content.getElementById(existingFilter.id);
            if (target) {
              target.open = existingFilter.open;
            }
          });
          tmpl.content.querySelectorAll('#facets details-disclosure > details').forEach((newFilter) => {
            if (this.expanded.includes(newFilter.id)) {
              const hiddenElements = newFilter.querySelectorAll('.js-hidden');
              hiddenElements.forEach((listItem) => {
                listItem.classList.remove('js-hidden');
              });
              newFilter.querySelector('.filter__more')?.remove();
            }
          });

          // Update the filters.
          this.form.innerHTML = tmpl.content.getElementById('facets').innerHTML;

          // Update the label of the mobile filter button
          closeBtn.innerText = tmpl.content.querySelector('.js-close-drawer-mob').innerText;

          // Preserve the CSS class of the results
          const currentResultsUl = this.results.querySelector('ul');
          this.currentResultsClass = currentResultsUl ? this.results.querySelector('ul').getAttribute('class') : this.currentResultsClass;

          // Update the results.
          this.results.innerHTML = tmpl.content.getElementById('filter-results').innerHTML;

          // Set the CSS class of the results to what it was
          const newResultsUl = this.results.querySelector('ul');
          if (newResultsUl && this.currentResultsClass) newResultsUl.setAttribute('class', this.currentResultsClass);

          // Reinitialize re-rendered components.
          this.addElements();
          this.addListeners();

          // Reinitialize any custom pagination
          if (customPagination && customPagination.reload) customPagination.reload();

          // Update the URL.
          if (updateUrl) FacetFilters.updateURL(searchParams);

          // Scroll to the top of the results if needed
          if (this.results.getBoundingClientRect().top < 0) {
            // If the header is sticky, compensate for it when scrolling to elements
            let headerHeight = 0;
            if (document.querySelector('store-header[data-is-sticky="true"]')) {
              headerHeight = Number.parseInt(
                getComputedStyle(this.parentElement)
                  .getPropertyValue('--header-height')
                  .replace('px', ''),
                10
              ) || 0;
            }
            window.scrollTo({
              top: this.results.getBoundingClientRect().top + window.scrollY - headerHeight - 45,
              behavior: 'smooth'
            });
          }

          // Enable the "Show X results" button
          closeBtn.classList.remove('is-loading');
          closeBtn.removeAttribute('aria-disabled');

          // Renable infinite scroll
          if (customPagination) customPagination.dataset.pauseInfiniteScroll = 'false';

          // Focus on the element with the same ID in the new HTML
          if (activeElementId) document.getElementById(activeElementId)?.focus();

          // Broadcast the update for anything else to hook into
          document.dispatchEvent(new CustomEvent('on:facet-filters:updated'), { bubbles: true });
        }
      } catch (error) {
        console.warn(error); // eslint-disable-line
      } finally {
        this.results.classList.remove('is-loading');
      }

      // ALEX - START - Custom - after DOM is replaced:
      document.dispatchEvent(new CustomEvent('on:facet-filters:updated', { bubbles: true }));
      // ALEX - END - Custom
    }

    /**
     * Updates the url with the current filter/sort parameters.
     * @param {string} searchParams - Filter/sort parameters.
     */
    static updateURL(searchParams) {
      window.history.pushState(
        { searchParams },
        '',
        `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`
      );
    }
  }

  customElements.define('facet-filters', FacetFilters);
}
